import { Component, Input } from '@angular/core';

@Component({
  selector: 'tun-playlists-icon',
  templateUrl: './playlists-icon.component.html',
  styleUrls: ['./playlists-icon.component.scss']
})
export class PlaylistsIconComponent {

  @Input() color: string;

  constructor() { }

}
